import { Helmet } from "react-helmet-async";
import SlidOnScrollBanner from "../components/slide-on-scroll-banner/SlidOnScrollBanner";
import Footer from "../components/footer/Footer";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import { UsaSectionsData } from "../data/UsaBannerData";
import OurTeams from "../components/our-teams/OurTeams";
import { usaHometabItems, usaHometabs } from "../data/usa-home-stack-data";
import SimpleModels from "../components/simpleEngagementModels";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import IndustriesSection from "../components/newIndustriesSection";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import { useTranslation } from "react-i18next";
import OurServices from "../components/our-services/OurServices";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import MegaMenu from '../components/MegaMenu/MegaMenu'
import AwardsAndPartners from "../components/AwardsAndPartners/AwardsAndPartners";

function UsaHome() {
  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });

  const { t: servicesSection } = useTranslation("ksaHome");
  const ksaHomehireServicesInsights = servicesSection("servicesInsights", { returnObjects: true, });
  const whyUsData = servicesSection("whyUs", { returnObjects: true, });


  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Bitsclan IT Solutions",
    "alternateName": "Bitsclan",
    "url": "https://bitsclan.com/",
    "logo": "https://bitsclan.com/images/logo.svg",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1(315)666-8052",
      "contactType": "technical support",
      "areaServed": "US",
      "availableLanguage": "en"
    },
    "sameAs": [
      "https://www.facebook.com/bitsclan",
      "https://x.com/bitsclan",
      "https://www.instagram.com/bitsclansolutions/",
      "https://www.youtube.com/@bitsclanitsolutions",
      "https://www.linkedin.com/company/bitsclanitsolutions",
      "https://bitsclan.com/"
    ]
  };

  return (
    <>
      <Helmet>
        <title>
          Award Winning Full Stack, AI Powered Software Development Company | Bitsclan
        </title>
        <meta
          name="description"
          content="Accelerate growth with Bitsclan’s award-winning team in AI, custom software, ecommerce, blockchain, web & mobile app development. From concept to launch, we deliver custom AI & IT solutions built for scalability and lasting success."
        />
        <script type="application/ld+json">
          {JSON.stringify(orgSchema)}
        </script>
      </Helmet>

      <MegaMenu />

      <SlidOnScrollBanner sectionsData={UsaSectionsData} />

      <TrustedPartner showGoogleIcons={true} />

      <OurServices buttonText="Build the Future With Us"
        servicesCardsData={ksaHomehireServicesInsights?.topBox}
        shortHeading={ksaHomehireServicesInsights?.shortHeading}
        mainHeading={ksaHomehireServicesInsights?.heading}
        description={ksaHomehireServicesInsights?.description} />

      <CoverTheStack
        whereStart={"AI/ML"}
        tabs={usaHometabs}
        tabItems={usaHometabItems}
        mainHeading={
          "Don't worry! We've got the tech stack you're looking for!"
        }
        secondSubHeading={
          "We have experts in almost all major & common tech stacks. Our team is rapidly expanding, covering more programming languages & expertise. You can be confident you'll get the experts you need when you work with us."
        }
      />

      <NewCaseStudySection
        shortHeading="Our Case Studies"
        heading="Enterprise Case Studies Validating Our Expertise"
        description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries."
      />

      <WhyChooseUs
        shortHeading="Why choose us"
        heading={whyUsData?.heading}
        greenHeading={whyUsData?.greenHeading}
        content={whyUsData?.description}
        stats={whyUsData?.stats}
        cta={whyUsData?.cta}
      />

      <SimpleModels content={engagementModelsContent} />

      <IndustriesSection />

      <AwardsAndPartners />

      {/* <OurTeams /> */}

      <TrendsInsights category="all" />

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
}

export default UsaHome;